import { getEnv } from 'common-nextjs';

/**
 * PayPal DDL script code without loading the actual script.
 * This sets up capturing events until the real script loads.
 *
 * See also: PaypalCashTrackerSnippet.tsx
 */
export function setupPaypalLocalCapture() {
  if (window.paypalDDL) return;

  window.paypalDDL = window.paypalDDL || [];

  const originalPush = window.paypalDDL.push;
  window.paypalDDL.push = function () {
    if (getEnv() !== 'production') {
      console.log(
        '[PayPal Local] paypalDDL.push called with args:',
        Array.prototype.slice.call(arguments, 0),
      );
    }
    // @ts-ignore
    return originalPush.apply(this, arguments);
  };

  window.paypalDDL.push({
    t: new Date().getTime(),
    event: 'snippetRun',
  });
}
